import { render, staticRenderFns } from "./OrderWasCreated.vue?vue&type=template&id=5caea49b&"
import script from "./OrderWasCreated.vue?vue&type=script&lang=js&"
export * from "./OrderWasCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports